(function () {
  var SELECTOR = 'form[data-ha-contact-form]';
  var MAX_FILE_BYTES = 5 * 1024 * 1024;
  var ALLOWED_EXTENSIONS = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'pdf', 'doc', 'docx', 'txt'];

  function getProxyUrl(form) {
    return (form.getAttribute('data-ha-contact-proxy') || '').trim();
  }

  function registerForms() {
    document.querySelectorAll(SELECTOR).forEach(bindForm);
  }

  function bindForm(form) {
    if (!form || form.dataset.haContactBound === 'true') return;
    if (!getProxyUrl(form)) return;

    form.dataset.haContactBound = 'true';
    form.setAttribute('novalidate', 'novalidate');

    form.addEventListener('change', function (event) {
      var target = event.target;
      if (target && target.type === 'file') {
        updateFileLabel(form, target);
      }
    });

    form.addEventListener(
      'submit',
      function (event) {
        event.preventDefault();
        event.stopPropagation();
        submitForm(form);
      },
      true
    );
  }

  function getMessage(form, key, fallback) {
    var value = form.getAttribute(key);
    return value && value.trim() ? value.trim() : fallback;
  }

  function getFeedbackEls(form) {
    return {
      success: form.querySelector('[data-ha-contact-success]'),
      error: form.querySelector('[data-ha-contact-error]'),
      fields: form.querySelector('[data-ha-contact-fields]'),
    };
  }

  function clearFeedback(form) {
    var els = getFeedbackEls(form);
    if (els.success) {
      els.success.hidden = true;
      els.success.textContent = '';
    }
    if (els.error) {
      els.error.hidden = true;
      els.error.textContent = '';
    }
  }

  function showSuccess(form) {
    var els = getFeedbackEls(form);
    clearFeedback(form);

    if (els.success) {
      els.success.textContent = getMessage(
        form,
        'data-ha-contact-success-message',
        'Merci pour votre message. Nous vous répondrons dans les plus brefs délais.'
      );
      els.success.hidden = false;
    }

    if (els.fields) {
      els.fields.hidden = true;
    }

    form.reset();
    updateFileLabel(form, form.querySelector('input[type="file"][name="attachment"]'));
  }

  function showError(form, message) {
    var els = getFeedbackEls(form);
    if (els.error) {
      els.error.textContent =
        message ||
        getMessage(form, 'data-ha-contact-error-message', 'Une erreur est survenue. Veuillez réessayer.');
      els.error.hidden = false;
    }
  }

  function setLoading(form, isLoading) {
    var button = form.querySelector('[type="submit"]');
    if (!button) return;
    button.disabled = isLoading;
    button.setAttribute('aria-busy', isLoading ? 'true' : 'false');
  }

  function validateFile(file, form) {
    if (!file || !file.size) return null;

    if (file.size > MAX_FILE_BYTES) {
      return getMessage(
        form,
        'data-ha-contact-file-too-large',
        'La pièce jointe ne doit pas dépasser 5 Mo.'
      );
    }

    var parts = file.name.split('.');
    var extension = parts.length > 1 ? parts.pop().toLowerCase() : '';
    if (extension && ALLOWED_EXTENSIONS.indexOf(extension) === -1) {
      return getMessage(
        form,
        'data-ha-contact-file-type-invalid',
        'Format de fichier non accepté. Formats autorisés : JPG, PNG, GIF, WEBP, PDF, DOC, DOCX, TXT.'
      );
    }

    return null;
  }

  function validateForm(form) {
    clearFeedback(form);

    var fields = form.querySelectorAll('[data-ha-contact-fields] [required]');
    var firstInvalid = null;

    fields.forEach(function (field) {
      field.setCustomValidity('');
      if (!field.checkValidity()) {
        if (!firstInvalid) firstInvalid = field;
      }
    });

    var fileInput = form.querySelector('input[type="file"][name="attachment"]');
    if (fileInput && fileInput.files && fileInput.files[0]) {
      var fileError = validateFile(fileInput.files[0], form);
      if (fileError) {
        showError(form, fileError);
        return false;
      }
    }

    if (firstInvalid) {
      firstInvalid.reportValidity();
      firstInvalid.focus();
      return false;
    }

    return true;
  }

  function buildFormData(form) {
    var data = new FormData();
    var name = form.querySelector('[name="name"]');
    var email = form.querySelector('[name="email"]');
    var requestType = form.querySelector('[name="request_type"]');
    var body = form.querySelector('[name="body"]');
    var attachment = form.querySelector('[name="attachment"]');
    var honeypot = form.querySelector('[name="company"]');

    data.set('name', name ? name.value.trim() : '');
    data.set('email', email ? email.value.trim() : '');
    data.set('request_type', requestType ? requestType.value : 'Other');
    data.set('body', body ? body.value.trim() : '');
    data.set('page_url', window.location.href);
    data.set('market', typeof currentMarketKey !== 'undefined' ? currentMarketKey : '');
    data.set('company', honeypot ? honeypot.value : '');

    if (attachment && attachment.files && attachment.files[0]) {
      data.set('attachment', attachment.files[0], attachment.files[0].name);
    }

    return data;
  }

  function mapApiError(code, form) {
    switch (code) {
      case 'missing_required_fields':
        return 'Veuillez remplir tous les champs obligatoires.';
      case 'invalid_email':
        return 'Veuillez saisir une adresse e-mail valide.';
      case 'invalid_attachment':
        return getMessage(
          form,
          'data-ha-contact-file-type-invalid',
          'Format de fichier non accepté.'
        );
      case 'forbidden_origin':
        return 'Soumission non autorisée depuis cette page.';
      default:
        return getMessage(
          form,
          'data-ha-contact-error-message',
          'Une erreur est survenue. Veuillez réessayer.'
        );
    }
  }

  function updateFileLabel(form, input) {
    if (!input) return;

    var label = form.querySelector('[data-ha-contact-file-name]');
    if (!label) return;

    if (input.files && input.files[0]) {
      label.textContent = input.files[0].name;
    } else {
      label.textContent = getMessage(form, 'data-ha-contact-file-empty', 'Aucun fichier sélectionné');
    }
  }

  function submitForm(form) {
    if (form.dataset.haContactSubmitting === 'true') return;
    if (!validateForm(form)) return;

    form.dataset.haContactSubmitting = 'true';
    clearFeedback(form);
    setLoading(form, true);

    fetch(getProxyUrl(form), {
      method: 'POST',
      body: buildFormData(form),
      mode: 'cors',
    })
      .then(function (response) {
        return response.json().then(function (payload) {
          return { ok: response.ok, payload: payload };
        });
      })
      .then(function (result) {
        if (result.ok && result.payload && result.payload.success) {
          showSuccess(form);
          return;
        }

        var code = result.payload && result.payload.error ? result.payload.error : 'server_error';
        showError(form, mapApiError(code, form));
      })
      .catch(function () {
        showError(
          form,
          getMessage(form, 'data-ha-contact-network-error', 'Erreur réseau. Veuillez réessayer.')
        );
      })
      .finally(function () {
        form.dataset.haContactSubmitting = 'false';
        setLoading(form, false);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', registerForms);
  } else {
    registerForms();
  }

  document.addEventListener('shopify:section:load', registerForms);
})();
